module.exports = __webpack_public_path__ + "img/logo_nomina.2984f4f7.png";